import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { getUserDto, getUserGoal } from '../../views/Activity/store/ActivitySelectors'
import YumChallengeTabs from './YumChallengeTabs'
import { getCurrentRoute } from '../../common/Routes/RouterSelector'

const mapStateToProps = (state: IGlobalState, ownProps: any) => ({
  userDto: getUserDto(state),
  goal: getUserGoal(state, ownProps.goalId),
  tab: ownProps.tab,
  currentRoute: getCurrentRoute(state),
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(YumChallengeTabs)
